import React from 'react';
import LegalTextPage from '../components/LegalTextPage.jsx';

const PrivacyPage = () => <LegalTextPage pageKey="privacy" pageId="privacy" />;

export default PrivacyPage;
